import { monthRange } from './alfawinMetrics.js';
import { numeric, sum } from './dashboardMetrics.js';
export const salesCostSources = {
  alfatex: 'Escandallo Alfatex', art: 'ART · PRECIO_C', missing_sheet: 'Artículo Alfatex sin escandallo utilizable',
  missing_art: 'Artículo/coste no disponible en ART', ambiguous_product: 'Código duplicado en Alfatex', ambiguous_art: 'Código duplicado en ART',
};
export function salesStudyMetrics(data, filters) {
  const months = monthRange(filters.from, filters.to).map((month) => {
    const row = data.months.find((r) => r.month === month) || {};
    const partial = ['missing_cost_lines', 'invoices_without_lines', 'mismatched_invoices', 'unknown_invoice_totals'].some((key) => numeric(row[key]) > 0);
    const revenue = numeric(row.revenue), cost = numeric(row.known_cost);
    return { ...row, month, revenue, cost, partial, margin: revenue - cost };
  });
  const partial = months.some((r) => r.partial);
  return { months, revenue: sum(months, 'revenue'), cost: sum(months, 'cost'), partial,
    margin: sum(months, 'revenue') - sum(months, 'cost'),
    coverage: missingCostCoverage(data.lines || []),
    missing: sum(months, 'missing_cost_lines'), alfatex: sum(months, 'alfatex_lines'), art: sum(months, 'art_lines') };
}

export function costIssue(line) {
  if (line.cost != null) return null;
  if (line.quantity == null) return { key: 'quantity', label: 'Cantidad no disponible', action: 'Revisar la cantidad de la línea en el ERP y su sincronización.' };
  const issues = {
    missing_sheet: ['Escandallo ausente o vacío', 'Revisar el artículo en Alfatex y completar su escandallo de materiales y procesos.'],
    missing_art: ['Artículo o PRECIO_C no disponible', 'Revisar el código y PRECIO_C en ART del ERP; después volver a sincronizar.'],
    ambiguous_product: ['Código duplicado en Alfatex', 'Revisar los artículos de Alfatex con este código y corregir la duplicidad.'],
    ambiguous_art: ['Código duplicado en ART', 'Revisar los códigos de ART, incluidos espacios exteriores, y volver a sincronizar.'],
  };
  const [label, action] = issues[line.cost_source] || ['Coste no calculable', 'Revisar cantidad, artículo y origen del coste.'];
  return { key: line.cost_source || 'unknown', label, action };
}

export function missingCostCoverage(lines) {
  const missing = lines.filter((r) => r.cost == null);
  const absoluteRevenue = sum(missing, (r) => Math.abs(numeric(r.revenue)));
  const allAbsoluteRevenue = sum(lines, (r) => Math.abs(numeric(r.revenue)));
  const groups = new Map();
  for (const line of missing) {
    const issue = costIssue(line);
    const group = groups.get(issue.key) || { ...issue, rows: [], revenue: 0, absoluteRevenue: 0 };
    group.rows.push(line); group.revenue += numeric(line.revenue); group.absoluteRevenue += Math.abs(numeric(line.revenue));
    groups.set(issue.key, group);
  }
  return { rows: missing, revenue: sum(missing, 'revenue'), absoluteRevenue,
    share: allAbsoluteRevenue ? absoluteRevenue / allAbsoluteRevenue * 100 : null,
    unknownRevenue: missing.filter((r) => r.revenue == null).length,
    groups: [...groups.values()].sort((a,b) => b.absoluteRevenue-a.absoluteRevenue) };
}

// Group signed line amounts, never invoice headers (which would duplicate sales).
export function salesByFamily(lines = []) {
  const groups = new Map();
  for (const line of lines) {
    const code = line.family_code?.trim() || null;
    const group = groups.get(code) || { code, name: line.family_name?.trim() || (code ? `Familia ${code}` : 'Sin familia'), rows: [], revenue: 0, unknownRevenue: 0 };
    group.rows.push(line);
    group.revenue += numeric(line.revenue);
    if (line.revenue == null) group.unknownRevenue++;
    groups.set(code, group);
  }
  return [...groups.values()].sort((a, b) => b.revenue - a.revenue || a.name.localeCompare(b.name, 'es'));
}
